import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Dialog } from "@material-ui/core";
import { withTranslation } from "react-i18next";

// Icons
import { CheckCircleOutline } from "@material-ui/icons";

// Actions
import {
  resendVerificationCode,
  submitVerificationCode,
  pushNotification,
} from "../../actions/index";

// Components
import ReCAPTCHA from "react-google-recaptcha";

// const sitekey = process.env.REACT_APP_CAPTCHA_SITEKEY;

function VerificationModal(props) {
  const { t, classes, verifying, account, emailCodeResent } = props;
  const [confirmationCode, setConfirmationCode] = useState("");
  const [acquiredCaptcha, setAcquiredCaptcha] = useState(false);
  const [captchaReady, setCaptchaReady] = useState(true);
  const captchaRef = useRef();
  const [codeResent, setCodeResent] = useState(false);
  const [codeSent, setCodeSent] = useState(false);

  // useEffect(() => {
  //   if (verifying) {
  //     props.resendVerificationCode({ email: account.account.email });
  //   }
  // }, [verifying]);

  const submitCode = async () => {
    props.submitVerificationCode({
      email: account.account.email,
      // "g-recaptcha-response": token,
      confirmation_code: confirmationCode,
    });
  };

  useEffect(() => {
    if (emailCodeResent.codeSent) {
      props.pushNotification({
        message: "codeSent",
        type: "error",
      });
    }

    if (emailCodeResent.error) {
      props.pushNotification({
        message: "somethingWentWrong",
        type: "error",
      });
    }
  }, [emailCodeResent]);

  const cancelVerification = () => {
    props.closeVerifying(false);
    setConfirmationCode("");
  };

  const resendEmail = (e) => {
    if (e === "resent") {
      let obj = {
        email: account.account.email,
      };

      props.resendVerificationCodeSettings(obj);
    } else {
      setCodeSent(true);
      let obj = {
        email: account.account.email,
      };

      props.resendVerificationCodeSettings(obj);
    }
  };

  return (
    <Dialog
      open={verifying}
      //   open
      classes={{
        paper: classes.verificationModalPaper,
        root: classes.verificationModalRoot,
      }}
    >
      <div className="verificationHeader">
        <p>{t("emailVerification")}</p>
      </div>
      <div className="verificationBody">
        <h1>{t("checkInbox")}</h1>
        <p
          dangerouslySetInnerHTML={{
            __html: t("verificationNotice", {
              user_email: account.account.email,
              // user_email: "email@email.com",
            }),
          }}
        />
        {codeSent ? (
          <input
            type="text"
            onChange={(e) => setConfirmationCode(e.target.value)}
            placeholder={t("enterVerificationCode")}
          />
        ) : (
          <button className={classes.sendCodeBtn} onClick={() => resendEmail()}>
            {t("sendCode")}
          </button>
        )}

        {codeResent ? (
          <p className={classes.codeSent}>
            {t("codeSentEmail")} <CheckCircleOutline />
          </p>
        ) : codeSent ? (
          <p
            className={classes.codeSent}
            style={{ color: "white", textDecoration: "underline" }}
            onClick={() => resendEmail("resent")}
          >
            {t("noEmailReceived")}
          </p>
        ) : (
          ""
        )}
        {/* <ReCAPTCHA
          ref={captchaRef}
          sitekey={sitekey}
          theme="dark"
          size="invisible"
        /> */}
        <div className="verificationBtns">
          <button className="cancelBtn" onClick={() => cancelVerification()}>
            {t("cancel")}
          </button>
          <button
            disabled={confirmationCode === "" ? true : false}
            onClick={() => submitCode()}
          >
            {t("verify")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
    emailCodeResent: state.emailCodeResent,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      resendVerificationCode,
      submitVerificationCode,
      pushNotification,
    },
    dispatch
  );
}

const styles = (theme) => ({
  codeSent: {
    fontSize: "18px !important",
    // fontFamily: "Titillium Web",
    color: theme.colors.text.secondary,
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginLeft: 5,
      color: theme.colors.buttons.buy,
    },
  },
  sendCodeBtn: {
    ...theme.defaults.roundBtn,
    background: theme.colors.background.active,
    marginBottom: 12,
    maxWidth: 200,
  },
  verificationModalPaper: {
    borderRadius: 16,
    background: "none",
    color: theme.colors.text.primary,
    maxWidth: 700,
    width: "95%",
    "& .verificationHeader": {
      height: 75,
      background: theme.colors.background.fore,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& .verificationBody": {
      background: theme.colors.background.main,
      padding: "24px 40px",
      "& h1": {
        fontSize: 24,
        fontWeight: 600,
      },
      "& p": {
        // fontFamily: "Titillium Web",
        color: theme.colors.text.secondary,
        marginTop: 8,
        marginBottom: 16,
      },
      "& input": {
        ...theme.defaults.input,
        marginBottom: 12,
      },
      "& .verificationBtns": {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 24,
        "& button": {
          ...theme.defaults.roundBtn,
          marginLeft: 8,
          background: theme.colors.buttons.green,
          "&.cancelBtn": {
            background: "none",
            borderColor: theme.colors.text.primary,
            marginLeft: "none",
          },
        },
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(VerificationModal)
  )
);
